var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row row-align-stretch"},[_c('div',{staticClass:"col-12 col-lg-6"},[_c('password-change')],1),_c('div',{staticClass:"col-12 col-lg-6"},[_c('profile-edit-contact-form')],1),_c('div',{staticClass:"col-12 col-lg-6"},[_c('SetPhoneLogin'),_c('TwoFa')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }